import './style.scss'
// import React from "react"

function PageNotfound() {
    return (
        <div className='pageNotFound'>
            <div className='mainText'>
                404
            </div>
            <div className='secondText'>
                Page Not Found
            </div>
        </div>
    )
}

export default PageNotfound